var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#arrow-down';
                    var viewUrl = 'svg/icons.svg#view-arrow-down';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };